import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/svg/illustrations/progress.svg')"}
}
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-20" }
const _hoisted_3 = { class: "pt-lg-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder fs-4x text-gray-700 mb-10" }, "Page Not Found", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3 text-gray-400 mb-15" }, [
  /*#__PURE__*/_createTextVNode(" The page you looked not found! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Plan your blog post by choosing a topic ")
], -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Go to homepage")
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column-auto p-10\"><div class=\"d-flex align-items-center fw-bold fs-6\"><a href=\"#\" class=\"text-muted text-hover-primary px-2\">About</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact Us</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: "btn btn-lg btn-primary fw-bolder"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_8
  ]))
}